var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAceptInfoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 90,
    viewBox: "0 0 82 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.8665 8.68167C47.0213 9.01457 34.5904 -0.0022048 25.9917 0.160376C17.3929 0.322956 -0.578666 5.60554 0.16198 45.1668C0.902625 84.7281 25.3078 90.0804 34.7684 89.9049C79.06 89.0765 96.4742 8.0907 64.8665 8.68167Z",
    fill: "#E9EBF1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.9838,
    cy: 47.3991,
    r: 26.4516,
    fill: "#A0D9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8225 47.3991C16.8225 33.683 27.2638 22.4082 40.629 21.0817C39.7593 20.994 38.8767 20.9475 37.9838 20.9475C23.3748 20.9475 11.5322 32.7901 11.5322 47.3991C11.5322 62.0082 23.3748 73.8507 37.9838 73.8507C38.8767 73.8507 39.7593 73.8043 40.629 73.7165C27.2638 72.3901 16.8225 61.1153 16.8225 47.3991Z",
    fill: "#0099FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.407 75.9141L70.2315 74.0895L73.8805 77.7386L72.056 79.5631L68.407 75.9141Z",
    fill: "#D31313"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.865 67.2256L72.514 63.5766L74.3385 65.4011L70.6895 69.0501L68.865 67.2256Z",
    fill: "#D31313"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3739 77.7185L62.0229 74.0695L63.8474 75.894L60.1984 79.543L58.3739 77.7185Z",
    fill: "#D31313"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9193 12.6044C59.9193 14.7386 61.6561 16.4753 63.7903 16.4753C65.9245 16.4753 67.6612 14.7386 67.6612 12.6044C67.6612 10.4702 65.9245 8.7334 63.7903 8.7334C61.6561 8.7334 59.9193 10.4702 59.9193 12.6044ZM62.5 12.6044C62.5 11.8947 63.078 11.314 63.7903 11.314C64.5025 11.314 65.0806 11.8947 65.0806 12.6044C65.0806 13.314 64.5025 13.8947 63.7903 13.8947C63.078 13.8947 62.5 13.314 62.5 12.6044Z",
    fill: "#D31313"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9839 75.7864C22.3323 75.7864 9.5968 63.0509 9.5968 47.3993C9.5968 31.7477 22.3323 19.0122 37.9839 19.0122C43.4291 19.0122 48.7245 20.5658 53.2974 23.4999L51.2045 26.7567C47.2587 24.2251 42.6858 22.8832 37.9839 22.8832C24.4665 22.8832 13.4678 33.8819 13.4678 47.3993C13.4678 60.9167 24.4665 71.9154 37.9839 71.9154C51.5013 71.9154 62.5 60.9167 62.5 47.3993C62.5 46.5916 62.4613 45.7916 62.3865 45.0045L66.2394 44.6303C66.3271 45.5438 66.371 46.4651 66.371 47.3993C66.371 63.0509 53.6355 75.7864 37.9839 75.7864Z",
    fill: "#093C5D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2096 53.851C40.7142 53.851 40.2187 53.6626 39.8419 53.2832L28.229 41.6703L30.9671 38.9323L41.2122 49.1774L68.229 22.1606L70.9671 24.8987L42.58 53.2858C42.2006 53.6626 41.7051 53.851 41.2096 53.851Z",
    fill: "#093C5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAceptInfoLogo);
export default __webpack_public_path__ + "static/media/AceptInfoLogo.105db9d5c0dea19d5832c3676b8c3fb4.svg";
export { ForwardRef as ReactComponent };